import { render, staticRenderFns } from "./TabsCombination.vue?vue&type=template&id=9a09516e&scoped=true&"
import script from "./TabsCombination.vue?vue&type=script&lang=js&"
export * from "./TabsCombination.vue?vue&type=script&lang=js&"
import style0 from "./TabsCombination.vue?vue&type=style&index=0&id=9a09516e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a09516e",
  null
  
)

export default component.exports